var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showChange
    ? _c("change-password", {
        attrs: { error: _vm.error, loading: _vm.loading },
        on: {
          "cancel-change": _vm.cancelChange,
          "submit-change": _vm.onUpdatePassword
        }
      })
    : _vm.showConfirm
    ? _c("confirm-auth", {
        attrs: {
          error: _vm.error,
          details: _vm.confirmDetails,
          "confirm-state": _vm.signInConfirm
        },
        on: {
          "cancel-confirm": _vm.cancelConfirm,
          "submit-confirm": _vm.onConfirmSignin
        }
      })
    : _c(
        "div",
        { staticClass: "auth-screen" },
        [
          _c("loading-spinner", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading"
              }
            ]
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-between"
            },
            [
              _c("h2", { staticClass: "mb-4" }, [
                _vm._v("\n      Account Access\n    ")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-container",
            { staticClass: "auth-block has-border" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "user-emailid" } }, [
                        _vm._v("Email")
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: { id: "user-emailid", size: "md", type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              $event.keyCode !== 13
                            ) {
                              return null
                            }
                            return _vm.onSignIn($event)
                          }
                        },
                        model: {
                          value: _vm.authData.username,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.authData,
                              "username",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "authData.username"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "user-password" } }, [
                        _vm._v("Password")
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link forgot-pw",
                          attrs: { type: "button" },
                          on: { click: _vm.onForgotPassword }
                        },
                        [_vm._v("\n          I forgot\n        ")]
                      ),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: {
                          id: "user-password",
                          size: "md",
                          type: "password"
                        },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              $event.keyCode !== 13
                            ) {
                              return null
                            }
                            return _vm.onSignIn($event)
                          }
                        },
                        model: {
                          value: _vm.authData.password,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.authData,
                              "password",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "authData.password"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "ml-3 mt-3 d-flex justify-content-end" },
                    [
                      !!_vm.error
                        ? _c(
                            "div",
                            {
                              staticClass: "mr-4 alert alert-danger fade show",
                              attrs: { role: "alert" }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.error) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "submit-btn-ct" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn-block",
                              attrs: { variant: "primary", title: "Sign In" },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    $event.keyCode !== 13
                                  ) {
                                    return null
                                  }
                                  return _vm.onSignIn($event)
                                },
                                click: _vm.onSignIn
                              }
                            },
                            [_vm._v("\n            Sign In\n          ")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4 d-flex" }, [
            _c("div", { staticClass: "flex-1" }, [
              _vm._v(
                "\n      At CDS Global ensuring online security is a high priority. "
              ),
              _c("br"),
              _vm._v(
                "\n      The following measures are designed to ensure your communications\n      and transactions on this CDS Global website are as safe and reliable\n      as any other means of doing business with us.\n    "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-1" }, [
              _c("ol", [
                _c("li", [
                  _vm._v(
                    "\n          Only individuals authorized by CDS Global may use this system\n          and its resources.\n        "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("Unique IDs and passwords are required for all users.")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n          All users of the system are subject to having their activities\n          monitored and reviewed.\n        "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n          CDS Global, at its sole discretion, may revoke or terminate a\n          user’s access at any time.\n        "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n          Should you require assistance, please contact the CDS Global\n          Help Desk.\n        "
                  )
                ])
              ])
            ])
          ])
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }